import { Injectable } from '@angular/core';
import { codigoInstalacion, usuarioEmail } from '@models/global.models';
import { UsuarioActualModel } from '@models/login.models';
import { ConfiguracionState } from '@store/models/store.models';

@Injectable({
  providedIn: 'root',
})
export class PersistenciaService {
  constructor() { }

  setLocal(key: string, data: any) {
    try {
      localStorage.setItem(key, data);
    } catch (e) {
      console.log('Error en storage: ', e);
    }
  }

  getLocal(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.log('Error en storage: ', e);
      return;
    }
  }

  setCodigoInstalacion(
    arrayCodigosInstalacionAnterior: Array<codigoInstalacion>
  ) {
    let arrayAEnviar = [...arrayCodigosInstalacionAnterior];
    let arrayCodigosInstalacion = this.getCodigosInstalacion();
    if (arrayCodigosInstalacion) {
      arrayCodigosInstalacion.forEach((codigoInstalacion) => {
        if (
          arrayAEnviar.filter((codInstalacion) => codInstalacion.codigoInstalacion == codigoInstalacion.codigoInstalacion).length == 0) {
          arrayAEnviar.push(codigoInstalacion);
        }
      });
    }

    localStorage.setItem('codigosInstalacion', JSON.stringify(arrayAEnviar));
  }

  getCodigosInstalacion(): Array<codigoInstalacion> | null {
    let codigosInstalacion = localStorage.getItem('codigosInstalacion');
    let arrayCodigosInstalacion = null;
    if (codigosInstalacion) {
      arrayCodigosInstalacion = JSON.parse(
        codigosInstalacion
      ) as Array<codigoInstalacion>;
      if (arrayCodigosInstalacion.length == 0) {
        arrayCodigosInstalacion = null;
      }
    }
    return arrayCodigosInstalacion;
  }

  setUsuarioActual(usuarioActual: UsuarioActualModel) {
    this.removeusuarioActual();
    localStorage.setItem('usuarioActual', JSON.stringify(usuarioActual));
  }

  getusuarioActual(): UsuarioActualModel | null {
    let usuarioActualRepuesta = null;
    let usuarioActual = localStorage.getItem('usuarioActual');
    if (usuarioActual) {
      usuarioActualRepuesta = JSON.parse(usuarioActual) as UsuarioActualModel;
    }
    return usuarioActualRepuesta;
  }

  setEmailUsuarioActual(emailUsuarioActual: Array<usuarioEmail>) {
    // localStorage.setItem('usuariosEmails', JSON.stringify(emailUsuarioActual));
    let arrayAEnviar = [...emailUsuarioActual];
    let arrayEmailsUsuarios = this.getDatosUsuarioActual();
    if (arrayEmailsUsuarios) {
      arrayEmailsUsuarios.forEach((emails) => {
        if (
          arrayAEnviar.filter((userEmail) => userEmail.email == emails.email).length == 0) {
          arrayAEnviar.push(emails);
        }
      });
    }
    localStorage.setItem('usuariosEmails', JSON.stringify(arrayAEnviar));
  }

  getDatosUsuarioActual(): Array<usuarioEmail> | null {
    let usuariosEmails = localStorage.getItem('usuariosEmails');
    let arrayUsuarioActualRepuesta = null;
    if (usuariosEmails) {
      arrayUsuarioActualRepuesta = JSON.parse(usuariosEmails) as Array<usuarioEmail>;
    }
    if (arrayUsuarioActualRepuesta?.length == 0) {
      arrayUsuarioActualRepuesta = null
    }
    return arrayUsuarioActualRepuesta;
  }

  removeusuarioActual() {
    localStorage.removeItem('usuarioActual');
  }

  removeInstalacion(codigoInstalacionAEliminar: string) {
    let arrayAEnviar: any[] = [];
    let arrayCodigosInstalacion = this.getCodigosInstalacion();
    if (arrayCodigosInstalacion) {
      arrayCodigosInstalacion.forEach((codigoInstalacion) => {
        if (codigoInstalacion.codigoInstalacion != codigoInstalacionAEliminar) {
          arrayAEnviar.push(codigoInstalacion);
        }
      });
      localStorage.removeItem('codigosInstalacion');
      localStorage.removeItem('usuarioActual');
      localStorage.setItem('codigosInstalacion', JSON.stringify(arrayAEnviar));
    }
  }

  recuperarDatos(): ConfiguracionState {
    return new ConfiguracionState(
      this.getCodigosInstalacion(),
      this.getusuarioActual(),
      null,
      null,
    );
  }
}
